module.exports = __webpack_public_path__ + "static/media/she_is_strong_sign.bc167c7e.png";